/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IGdnPartSmartViewProps } from './gdn-part-smart';

export default (props: IGdnPartSmartViewProps) => {
    return <div className='partsmart-container' ref={props.containerRef}></div>;
};
